import React from "react";
import useResponsive from "../hooks/useResponsive";

/**
 * Reusable consultant profile section - two columns (left: personal/contact, right: about/skills).
 * Used in Consultant Management detail and Consultant Activity detail for the same UI.
 */
const ConsultantProfileSection = ({
  leftData = [],
  rightData = [],
  className = "",
  style = {},
  leftLabelMinWidth = "120px",
  rightLabelMinWidth = "140px",
  compact = false,
}) => {
  const { isMobile } = useResponsive();
  const rowGap = compact ? 10 : 6;
  const colGap = compact ? 10 : 10;
  const wrapperGap = compact ? 40 : isMobile ? 16 : 28;
  const rowStyle = {
    display: "flex",
    gap: "8px",
    marginBottom: rowGap,
    minWidth: 0,
    overflow: "hidden",
    minHeight: compact ? "20px" : "24px",
  };
  const labelStyle = (minWidth) => ({
    fontWeight: 600,
    flexShrink: 0,
    minWidth,
  });
  const valueStyle = {
    minWidth: 0,
    overflow: "hidden",
    wordBreak: "break-word",
  };

  return (
    <div
    className={`user_detail_container ${compact ? "" : "mb-4"} ${className}`.trim()}
    style={{
      ...style,
      height: "auto"
    }}
  >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: isMobile ? "column" : "row",
          gap: wrapperGap,
          ...(compact ? {} : { minHeight: isMobile ? "auto" : "240px" }),
        }}
      >
        <div style={{ flex: compact ? "0 1 auto" : "1 1 300px", minWidth: 0, overflow: "hidden" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: colGap }}>
            {leftData.map((item, idx) => (
              <div key={idx} style={rowStyle}>
                <span style={labelStyle(compact ? "110px" : leftLabelMinWidth)}>{item.label}:</span>
                <span style={valueStyle}>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ flex: compact ? "0 1 auto" : "1 1 300px", minWidth: 0, overflow: "hidden" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: colGap }}>
            {rightData.map((item, idx) => (
              <div key={idx} style={rowStyle}>
                <span style={labelStyle(compact ? "100px" : rightLabelMinWidth)}>{item.label}:</span>
                <span style={valueStyle}>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultantProfileSection;
